import React, { Component } from 'react';
import {AUDIO} from 'constants/track-types.js';
import {updateTrackMute} from 'operations/actions.js';
import LockButton from 'components/LockButton.js';
import TrackMeter from './TrackMeter.js';
import {getVolume} from 'utils/getVolume.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {setContextualHelp} from "actions/index.js";
import {TRACK_MUTE_BUTTON} from 'constants/contextual-help.js';
import {TRACK_SOLO_BUTTON} from 'constants/contextual-help.js';
import {TRACK_RECORD_ARM_BUTTON} from 'constants/contextual-help.js';
import {TRACK_VOLUME_SLIDER} from 'constants/contextual-help.js';
import { connect } from "react-redux";

import '../animation.css';

class TrackVolumeContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    onToggleClicked() {
        this.props.trackData.toggleEnabled();
        this.setState(this.state);
    }

    onMuteClicked() {
        this.props.sequencerEngine.operationManager.dispatch(
            updateTrackMute(this.props.trackData, !this.props.muted));
        this.setState(this.state);
    }

    onSoloClicked() {
        this.props.trackData.solo(!this.props.solo);
    }

    onChangeVolume(volume) {
    }

    // called when user slides the volume knob
    onChangeVolume(volume) {
        if (volume === undefined) {
            return;
        }


        volume = parseFloat(volume);
        this.props.trackData.setVolume(volume);
        this.setState(this.state);
    }

    setContextualHelp(e, help) {
        e.stopPropagation(e);
        this.props.setContextualHelp(help);
    }

    toggleLock() {
        this.props.trackData.togglePatternLock();
    }

    render() {
        let trackTriggeringClassName = this.props.triggering == true ? ' flashit ' : '';
        let muteClassName = this.props.muted ? trackTriggeringClassName + "mute-button muted" :
            trackTriggeringClassName + "mute-button";

        if (this.props.isCompactMode) {
            muteClassName += ' compact';
        }
        return (
            <div className="track-controls">
              <div className="row">
            <div className="volume-container">
               <div
                  onMouseOver={(e) => this.setContextualHelp(e, TRACK_MUTE_BUTTON)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  className={muteClassName}
                  onClick={() => this.onMuteClicked()}>
                  {this.props.trackNumber + 1}
                </div>
                <div onClick={() => this.onSoloClicked()}
                  onMouseOver={(e) => this.setContextualHelp(e, TRACK_SOLO_BUTTON)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  className={this.props.solo ? "track-solo-button on" : "track-solo-button off"}>
                  S
                </div>
              {!this.props.trackData.isFrozen || this.props.trackData.getTrackType() === AUDIO ?
                <div
                  onMouseOver={(e) => this.setContextualHelp(e, TRACK_RECORD_ARM_BUTTON)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  onClick={() => this.onToggleClicked()}
                  className={this.props.isEnabled ? "midi-recording-button on" : "midi-recording-button off"}>
                  <span className="black plain-dot"></span>
                </div> : ''}
            </div>

            <ConditionedComponent condition={!this.props.isCompactMode}>
              {this.props.isSelectedTrack ? 
              <TrackMeter meter={this.props.trackData.trackMeter}/> : <div className="ghost-meter"></div>}
            </ConditionedComponent>
              </div>
              {this.props.showEffects ?
               <div className="effect-lock">
                 <LockButton
                   patternLocked={this.props.patternLocked}
                   toggleLock={() => this.toggleLock()}/>
               </div> : ''}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
};
 
const mapStateToProps = (state, ownProps) => {
    let track = ownProps.trackData;
    let volume = state.tracks.trackVolumes[track.id];
    let muted = state.tracks.trackMutes[track.id]; 
    let solo = state.tracks.trackSolos[track.id]; 
    let enabledMap = state.tracks.trackIsEnabled[track.subSequence.id] || {};
    let isEnabled = enabledMap[track.id]; 
    let trackTriggers = state.tracks.triggers[ownProps.trackNumber];
    let triggering = trackTriggers === undefined ? false :
        Object.keys(trackTriggers).some(
        slice => trackTriggers[slice] === true);

    let subSequenceLocks = state.tracks.trackPatternLocks[track.subSequence.id] || {};
    let patterns = subSequenceLocks[track.trackNumber] || {};
    let locked = patterns[track.currentPattern] || false;
    return {
        trackNumber: track.trackNumber,
        patternLocked: locked,
        triggering: triggering,
        volume: volume === undefined ? 0 : volume,
        muted:  muted === undefined ? false : muted,
        solo:  solo === undefined ? false : solo,
        isEnabled:  isEnabled === undefined ? false : isEnabled,
        isCompactMode: state.sequencer.isCompactMode,
        isFrozen: ownProps.trackData.isFrozen,
        showEffects: state.tracks.showTrackEffects[ownProps.trackData.trackNumber],
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackVolumeContainer);
